/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SendOfferAndDownload$Params {
  id: number;
  includeDiscounts?: boolean;
}

export function sendOfferAndDownload(http: HttpClient, rootUrl: string, params: SendOfferAndDownload$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, sendOfferAndDownload.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('includeDiscounts', params.includeDiscounts, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

sendOfferAndDownload.PATH = '/offers/{id}/send';
